module.exports = __webpack_public_path__ + "static/media/StephouseQuickGuide.868ca168.webp";